// extracted by mini-css-extract-plugin
module.exports = {"headerMenu":"header_headerMenu__dCROO","bannerImage":"header_bannerImage__Ak5Ve"};